<!--
   相关图片
 * @Author: lixiaodi
 * @Date: 2020-03-19 13:09:34
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-12-03 14:08:41
 -->
<template>


  <div class="desc-box" style="margin-top: 10px;">
    <!-- 标题 -->
    <div class="title-left">相关图片</div>
    <!-- 推荐内容 -->
    <div class="swiper-box" v-if="pages.length">
      <swiper :options="swiperOption2">
        <swiper-slide v-for="(page, index) of pages" :key="index" class="flex-box">

          <div class="recom-box" v-for="item of page" :key="item.id" @click="toImg(item.VAttachmentId)">
            <div class="file-img">
              <img :src="item.VAttachmentRemotePath" alt="" >
            </div>
            <div class="file-info">
              <p>{{item.VAttachmentName}}</p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" id="swiper-pagination2"  slot="pagination"></div>
      </swiper>
      <!-- 箭头 -->
      <div class="swiper-button-prev" id="swiper-button-prev2"></div>
      <div class="swiper-button-next" id="swiper-button-next2"></div>
    </div>
  </div>
</template>

<script>
// import InfoList from './infoList'
import Swiper from 'swiper'
export default {
  name: 'CorrelationImage',
 /* components: {
      InfoList
  }*/
  data () {
    return {
      VAttachmentId: '',
      list: [],
      swiperOption2: {
        pagination: '#swiper-pagination2',
        autoplay: false,
        spaceBetween: 5,
        navigation: {
          prevEl: '#swiper-button-prev2',
          nextEl: '#swiper-button-next2'
        }
      }
    }
  },
  created() {
    // 得到教师id
    this.VAttachmentId = this.$route.query.VProductId;
    console.log(this.VAttachmentId)
    // 相关推荐数据
    this.onRecommendRes();
  },
  methods: {
    // 相关课件推荐
    onRecommendRes() {
      this.axios.post(window.IPConfig.IP + "/tBAttachments/getByIdQian.do?VAttachmentId="+this.VAttachmentId).then(res => {
        var keyrord = res.data.obj.keyrord;
        var VAttachmentName = res.data.obj.VAttachmentName;
        var VAttachmentId = res.data.obj.VAttachmentId;


        var data = {
          auditStatus: "1",
          VAttachmentType: '1',
          IProductStatut: 0,
          VAttachmentName: VAttachmentName == undefined ? '' : VAttachmentName,
          VAttachmentId: VAttachmentId == undefined ? '' : VAttachmentId,
          keyrord: keyrord == undefined ? '' : keyrord,
        }
        this.axios.post(window.IPConfig.IP + "/tBAttachments/queryCorrelationImage.do", data).then((res) => {
          this.rows = [];
          if (res.data.status == 200) {
            this.list = res.data.obj;
          }
        });
      })

    },
    // 点击教师文献跳转详情
    toImg (VAttachmentId){
      let routeData = this.$router.resolve({path:'imageDetails',query:{
          VProductId: VAttachmentId,
        }})

      window.open(routeData.href,'_blank')
    }
  },
  mounted() {
    this.$nextTick(() => {
      var swiper3 = new Swiper('#Right', {
        navigation: {
          nextEl: '#swiper-button-next2',
          prevEl: '#swiper-button-prev2',
        },
      })
    })
  },
  computed: {
    pages () {
      const pages = []
      this.list.forEach((item, index) => {
        // 通过item的数量判断页码，也就是轮播图的第几张图片
        const page = Math.floor(index / 5)
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    }
  }
}
</script>

<style lang="stylus" scoped>
.desc-box{
  background #fdffff
  //margin-bottom .1rem
}
.title-left{
  font-size: 0.16rem;
  // font-weight: bold;
  color: cadetblue;
  padding: 0.1rem 0.05rem;
  background: #f2f3f4;
  margin-bottom .1rem
}
/* 内容 */
.flex-box{
  display: flex
  //justify-content: space-around;
  //margin-left :15pxs
  //margin-right :15px
}
//.file-img{
//    text-align: center;
//    background: #f2f3f4;
//    padding: .15rem;
//}
//
.file-img{
  text-align: center;
  background: #f2f3f4;
  padding: .1rem;
  height: 1.9rem !important;
  width: 2.1rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.file-img img{
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
}
.file-info{
  background: #fdffff;
  //line-height: 2;
  padding: .1rem;
  box-sizing: border-box;
  text-align: center;
}
.info-price{
  display: flex;
  justify-content: center;
  /* justify-content: space-between; */
}
/* 轮播 */
.swiper-box{
  position relative
}
.swiper-button-prev{
  left .1rem
}
.swiper-button-next{
  right .1rem
}

.swiper-container {
  margin-left: 35px;
  margin-right: 35px;
}
.recom-box{
  margin :0 18px;
}
</style>
<!--<style lang="stylus" scoped>
.detail-box{
  margin-bottom 0.5rem
  background #fdffff
}
.detail-title{
  display flex
  justify-content space-between
  align-items center
  margin-bottom .1rem
}
.title-left{
  /* border-left 3px solid #00ae80 */
  /* padding-left .06rem */
  font-size: 0.16rem;
  color: #fff;
  padding: 0.1rem 0.05rem;
  background: #228457;
  margin-bottom: 0.1rem;
  width: 100%;
}
.title-right{
    display flex
}
.title-weight{
    font-weight 700
}
</style>-->



// WEBPACK FOOTER //
// src/components/Education/components/imageList/correlationImage.vue